<template lang="html">
  <div>

    <md-layout md-gutter="16" md-align="center">
      <md-layout md-flex="50">
        <label>Si ya eres cliente de Superticket: <br> 
        Por favor ingresa tu RFC, posteriormente te mandaremos a tu email tus datos de acceso a STShop </label>
        <md-layout md-flex="100">
          <md-input-container>
            <label>RFC</label>
            <md-input required v-model="rfc"></md-input>
          </md-input-container>
        </md-layout>
      </md-layout>
      <md-layout md-flex="60" md-align="end">
          <md-button class="md-primary md-raised" id="entrar" @click.native="ObtenerUsuario">
            Obtener Usuario
            
          </md-button>        
        </md-layout>
      
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';

export default {
  name: 'Recupera',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      pedidos: [],
      rfc: '',
    };
  },
  computed: {
  },
  components: {},
  methods: {
    ObtenerUsuario(){
      const data = {
        RFC: this.rfc
      };
      this.resourceCliente.RecuperaUsuario(data)
      .then((response) => {
        
        const message = "Se Envio un correo a su email '" + response.data.email + "' con sus datos para inicar sesion en STShop, Favor de revisarlo e iniciar Sesion para actualizar sus datos"
        alert(message);
        this.$toast.create('Se Envio un correo a su email, Favor de revisarlo e ingresar nuevamente para actualizar sus datos', 'snack', 3E3);            
        this.$router.push({ name: 'login' });
      })
      .catch((err) => {
        this.$toast.create('Ocurrio un error', 'snack', 3E3);
      });
    },
    toMoney,
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
    goToPedidos() {
      this.$router.push({ name: 'pedido' });
    },
    goToInfo() {
      this.$router.push({ name: 'perfil' });
    },
  },
  mounted() {
    this.cart = window.cart;
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
  },
};
</script>

<style lang="scss">
.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/spa/recuperaUsuario/RecuperaUsuario.vue